export default {
  CAPTURE_AMOUNT_EXCEEDS_AUTHORIZED_AMOUNT: 'CAPTURE_AMOUNT_EXCEEDS_AUTHORIZED_AMOUNT',
  INPUT_VALIDATION_ERROR: 'INPUT_VALIDATION_ERROR',
  QS1_VALIDATION_FAILED: 'QS1_VALIDATION_FAILED',
};
